import React from 'react';
import Button from '@common/Button';
import {AutorenewRounded} from '@mui/icons-material';

const QuestionCard = ({number, text, onSwap}) => (
    <div className="ch-lesson-planner-question-card">
        <span className="ch-lesson-planner-question-card__number" aria-hidden="true">{number}.</span>
        <span className="ch-lesson-planner-question-card__text">{text}</span>
        {onSwap && (
            <div className="ch-lesson-planner-question-card__swap-wrap">
                <Button
                    type="text"
                    className="ch-lesson-planner-question-card__swap-btn"
                    icon={<AutorenewRounded />}
                    aria-label={`Replace question ${number}`}
                    onClick={() => onSwap(number)}
                >
                    Replace
                </Button>
            </div>
        )}
    </div>
);

export default QuestionCard;
